/* Troubleshooting accordion (device detail + biometric help). */
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

interface Item { id: string; q: [string, string]; a: [string, string][]; link?: { to: string; label: [string, string] } }

export const TROUBLESHOOTING: Item[] = [
  { id: "offline", q: ["The device shows Offline", "الجهاز يظهر غير متصل"], a: [
    ["Check the device has internet: from the device menu, ping 8.8.8.8 (Comm. → Network diagnosis on ZKTeco).", "تأكد من اتصال الجهاز بالإنترنت: من قائمة الجهاز نفّذ ping إلى 8.8.8.8 (الاتصال ← تشخيص الشبكة في ZKTeco)."],
    ["Server address and port must be exactly as shown in the device's setup values.", "يجب أن يطابق عنوان الخادم والمنفذ القيم المعروضة في إعداد الجهاز تمامًا."],
    ["HTTPS on the device must match (On for port 443).", "يجب أن يطابق خيار HTTPS في الجهاز (مفعّل للمنفذ 443)."],
    ["Make sure the device date and time are correct — a wrong year breaks secure connections.", "تأكد من صحة تاريخ ووقت الجهاز — السنة الخاطئة تمنع الاتصال الآمن."],
  ] },
  { id: "never-pending", q: ["The device never appears under Pending devices", "الجهاز لا يظهر ضمن الأجهزة المعلقة"], a: [
    ["Check the serial number for typos (letters O/0 and I/1 are easy to mix up).", "تحقق من الرقم التسلسلي (من السهل الخلط بين O و0 وبين I و1)."],
    ["Turn on the \"Enable domain name\" option so the device can use the StartHR address.", "فعّل خيار «اسم النطاق» ليتمكن الجهاز من استخدام عنوان ستارت HR."],
    ["Ask IT whether the firewall blocks outgoing connections on port 443.", "اسأل قسم التقنية إن كان الجدار الناري يمنع الاتصالات الصادرة على المنفذ 443."],
  ] },
  { id: "blank-employee", q: ["Punches arrive but the employee is blank", "تصل البصمات لكن اسم الموظف فارغ"], a: [
    ["The user ID on the device isn't linked to an employee yet.", "رقم المستخدم في الجهاز غير مرتبط بموظف بعد."],
    ["Open the Unmatched inbox and choose Link to employee — past punches are fixed automatically.", "افتح صندوق غير المطابَقين واختر «ربط بموظف» — تُصحَّح البصمات السابقة تلقائيًا."],
  ], link: { to: "/biometric/unmatched", label: ["Open Unmatched inbox", "فتح صندوق غير المطابَقين"] } },
  { id: "time-off", q: ["Times are 3 hours off", "الأوقات متأخرة أو متقدمة 3 ساعات"], a: [
    ["Set the device time zone to +3 (Riyadh), or set the device's time zone in StartHR (Edit device).", "اضبط المنطقة الزمنية في الجهاز على ‎+3 (الرياض)، أو اضبطها للجهاز في ستارت HR (تعديل الجهاز)."],
  ] },
  { id: "duplicates", q: ["I see duplicate punches", "تظهر بصمات مكررة"], a: [
    ["That's normal — people often tap twice. StartHR ignores repeats within 2 minutes (Settings → Attendance).", "هذا طبيعي — كثيرًا ما يبصم الموظف مرتين. يتجاهل ستارت HR التكرار خلال دقيقتين (الإعدادات ← الحضور)."],
  ] },
  { id: "lan-only", q: ["LAN-only or old devices without a cloud option", "أجهزة قديمة أو على الشبكة المحلية فقط"], a: [
    ["Install the StartHR Agent on any office PC on the same network — it reads the device locally and sends punches securely.", "ثبّت وكيل ستارت HR على أي حاسب في نفس الشبكة — يقرأ الجهاز محليًا ويرسل البصمات بأمان."],
    ["Or export the attendance log from the device software and upload the CSV file.", "أو صدّر سجل الحضور من برنامج الجهاز وارفع ملف CSV."],
  ] },
];

export function Troubleshooting() {
  const { L } = useI18n();
  return (
    <div className="accordion" data-testid="troubleshooting">
      {TROUBLESHOOTING.map((it) => (
        <details key={it.id} data-testid={"ts-" + it.id}>
          <summary>{L(it.q[0], it.q[1])}</summary>
          <ul className="sm" style={{ margin: 0, paddingInlineStart: 20, display: "grid", gap: 6 }}>
            {it.a.map((x, i) => <li key={i}>{L(x[0], x[1])}</li>)}
          </ul>
          {it.link && <div className="mt"><Link className="btn sm" to={it.link.to}>{L(it.link.label[0], it.link.label[1])}</Link></div>}
        </details>
      ))}
    </div>
  );
}
